<template>
    <kgr-offering-view
        v-if="offering !== null"
        :club-id="clubId"
        :offering="offering"
        :user-id="userId"
        :error="error"
        :duplicate-url="duplicateUrl"
        :can-duplicate="canDuplicate"
        :can-edit="canEdit"
    />
</template>

<script>
import Error from '../../js/model/Error.js';
import ExamOfferingRepository from '../../js/repository/club/offering/ExamOfferingRepository.js'
import OfferingExamView from '../../components/offering/OfferingExamView.vue'

export default {
    components: {
        'kgr-offering-view': OfferingExamView,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        duplicateUrl: {
            type: String,
            required: true,
        },
        canDuplicate: {
            type: Boolean,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            offering: null,
            error: new Error(),
        }
    },
    computed: {},
    created() {
        ExamOfferingRepository.find(this.offeringId)
            .then(offering => this.offering = offering)
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {},
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
